import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/dre')({
  component: lazyRouteComponent(
    () => import('@/features/dre/components/dre-page'),
    'DrePage'
  ),
})
